const navbarStrings = {
    home: 'Inicio',
    menu: 'Menú',
    locationAndContact: 'Ubicación y Contacto',
};

export default navbarStrings;
